<template>

  <div class="articlemanagement">

    <Card :bordered="false">
      <div slot="title">
        <Row>
          <Col
            :xs="24"
            :sm="24"
            :md="10"
            :lg="10"
          >
          <Divider orientation="left">{{ langMap.taskExecution[lang] }}</Divider>
          </Col>
          <Col
            :xs="24"
            :sm="24"
            :md="14"
            :lg="14"
          >
          <Form :label-width="80">
            <div class="des-cardTittle-box">
              <FormItem
                :label="langMap.robot[lang]"
                class="leftFlex"
              >
                <Select
                  v-model="searchForm.robotId"
                  clearable
                >
                  <Option
                    :key="item.id"
                    :value="item.id"
                    v-for="item in robotList"
                  >{{item.name}}</Option>
                </Select>
              </FormItem>
              <FormItem
                :label="langMap.task[lang]"
                class="leftFlex"
              >
                <Select
                  v-model="searchForm.taskId"
                  clearable
                >
                  <Option
                    :key="item.id"
                    :value="item.id"
                    v-for="item in taskList"
                  >{{item.name}}</Option>
                </Select>
              </FormItem>
              <FormItem
                :label="langMap.status[lang]"
                class="leftFlex"
              >
                <Select
                  v-model="searchForm.status"
                  clearable
                >
                  <Option
                    :key="item.id"
                    :value="item.id"
                    v-for="item in taskExecuteStatusList"
                  >{{item.name}}</Option>
                </Select>
              </FormItem>
              <Button
                type="info"
                style="margin-left:20px;"
                @click="searchData"
              >{{ langMap.search[lang] }}</Button>
            </div>
          </Form>
          </Col>
        </Row>
      </div>
      <Table
        :height="height"
        :loading="tableLoading"
        border
        :columns="col"
        :data="taskExecuteList"
      ></Table>
      <!--分页数据-->
      <div
        style="text-align:center;padding-top:10px;"
        v-if="taskExecuteList.length>0"
      >
        <Page
          :current="index"
          :total="total"
          :page-size="15"
          @on-change="goPageData"
        ></Page>
      </div>
    </Card>

    <Modal
      v-model="detailModal"
      :title="langMap.cycleDetails[this.lang]"
      width="800"
    >
      <Table
        :loading="detailLoading"
        :columns="detailColumns"
        :data="detailList"
        border
      ></Table>
      <div style="text-align:center;padding-top:10px;" v-if="detailList.length>0">
        <Page
          :current="detailIndex"
          :total="detailTotal"
          :page-size="15"
          @on-change="handleDetailPageChange"
        ></Page>
      </div>
      <div slot="footer">
        <Button @click="detailModal = false">{{ langMap.close[this.lang] }}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import api from "../../../api/index.js";
import langMap from '@/utils/language';
import { formatTime } from '@/utils/dateTimeUtil'
import { mapState } from 'vuex';
export default {
  components: {},
  data() {
    return {
      langMap:langMap,
      height: document.documentElement.clientHeight - 300,
      robotList: [],
      taskList: [],
      taskExecuteStatusList: [],
        taskExecuteTaskTypeList: [],
      taskExecuteList: [],
      btnLoading: false,
      index: 1,
      total: 0,
      //表格
      tableLoading: false,
      searchForm: {
        robotId: "",
        taskId: "",
        status: ""
      },
      detailModal: false,         // 控制弹窗显示
      detailList: [],            // 详情数据列表
      detailIndex: 1,            // 详情分页当前页
      detailTotal: 0,            // 详情总条数
      detailLoading: false,      // 详情加载状态
      currentDetailId: null,     // 当前查看的任务ID
      actionLocked: false,       // 操作按钮锁定（二次确认通过后3秒内禁用）
      actionLockTimer: null      // 操作按钮锁定定时器
    };
  },
  computed: {
    ...mapState({
      lang: state => state.app.language // 修复语法错误:移除this
    }),
    col () {
      return [
        {
          title: "#",
          width: 80,
          key: "index",
          render(h, params) {
            return h("span", params.index + 1);
          }
        },
        {
          title: langMap.robot[this.lang],
          width: 120,
          key: "robotName"
        },
        {
          title: langMap.task[this.lang],
          width: 160,
          key: "taskName",
          render: (h, { row }) => {
            let text = row.taskName;
            return h("div", {style: {textAlign: "left"}}, text);
          }
        },
        {
          title: langMap.status[this.lang],
          key: "status",
          width: 120,
          render: (h, { row }) => {
            let text = row.type;
            this.taskExecuteStatusList.forEach((item, index, arr) => {
              if (item.id == row.status) {
                text = item.name;
              }
            });
            return h("span", text);
          }
        },
        {
          title: langMap.type[this.lang],
          key: "taskType",
          width: 120,
          render: (h, { row }) => {
            let text = row.taskType;
            this.taskExecuteTaskTypeList.forEach((item, index, arr) => {
                 if (item.id == row.taskType) {
                    text = item.name;
                 }
            });
            return h("span", text);
          }
        },
        {
          title: langMap.executionCount[this.lang],
          width: 120,
          key: "executeNumber"
        },
        {
          title: langMap.dispatchTime[this.lang],
          width: 210,
          key: "publishTime"
        },
        {
          title: langMap.receiveTime[this.lang],
          width: 210,
          key: "receiveTime"
        },
        {
          title: langMap.completionTime[this.lang],
          width: 210,
          key: "feedbackTime"
        },
        {
          title: langMap.operation[this.lang],
          align: "center",
          width: 235,
          fixed: 'right',
          render: (h, params) => {
            const buttonConfig = this.getButtonConfig();
            const renderArray = [];
            const status = params.row.status;
            // 根据状态显示不同按钮
            if (status === 4 && !this.isReturnTask(params.row)) {
              renderArray.push(this.createActionButton(h, buttonConfig.pause, params));
            }

            if (status === 12) {
              renderArray.push(this.createActionButton(h, buttonConfig.resume, params));
            }
            if ([4, 12].includes(status)) {
                renderArray.push(this.createActionButton(h, buttonConfig.terminate, params));
            }
            if (![4,12].includes(status)) {
                renderArray.push(this.createActionButton(h, buttonConfig.playback, params));
            }

            // 详情按钮始终显示
            buttonConfig.detail.isLast = true; // 最后一个按钮
            renderArray.push(this.createActionButton(h, buttonConfig.detail, params));
            
            return h("div", {
              style: {
                display: "flex",
                flexWrap: "wrap",
                gap: "4px",
                justifyContent: "center",
                alignItems: "center"
              }
            }, renderArray);
          }
        }
      ]
    },
    detailColumns() {
      return [
        {
          title: "#",
          width: 80,
          key: "index",
          render: (h, params) => {
            return h("span", params.index + 1);
          }
        },
        {
          title: langMap.pathName[this.lang],
          key: "pathName",
          width: 150
        },
        {
          title: langMap.cycles[this.lang],
          key: "cycles",
          width: 85
        },
        {
          title: langMap.nodeName[this.lang],
          key: "nodeName",
          width: 150
        },
        {
          title: langMap.createTime[this.lang],
          key: "createTime",
          width: 150
        },
        {
          title: langMap.messageTime[this.lang],
          width: 150,
          key: "timestamp",
          render: (h, params) => {
            const time = params.row.timestamp
            return h("span", time ? formatTime(time) : '');
          }
        }
      ];
    }
  },
  methods: {
    isReturnTask(row) {
      return Number(row && row.taskType) === 3;
    },

    hideText(h, text, width) {
      return h("div", [
        h(
          "Tooltip",
          {
            props: { placement: "top", transfer: true }
          },
          [
            h(
              "span",
              {
                style: {
                  display: "inline-block",
                  width: width,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap"
                }
              },
              text
            ),
            h(
              "span",
              {
                slot: "content",
                style: { whiteSpace: "normal", wordBreak: "break-all" }
              },
              text
            )
          ]
        )
      ]);
    },

    // 按钮配置定义
    getButtonConfig() {
      return {
        pause: {
          icon: 'ios-pause',
          type: 'warning',
          text: this.langMap.pause[this.lang],
          confirmContent: this.langMap.confirmPause[this.lang],
          successMsg: this.langMap.pauseSuccess[this.lang],
          endpoint: 'pause',
          gradient: 'linear-gradient(135deg, rgb(243 41 49) 0%, rgb(169 74 139) 100%)',
          shadowColor: 'rgba(255, 154, 158, 0.3)'
        },
        resume: {
          icon: 'ios-play',
          type: 'success', 
          text: this.langMap.recover[this.lang],
          confirmContent: this.langMap.confirmResume[this.lang],
          successMsg: this.langMap.playSuccess[this.lang],
          endpoint: 'recover',
          gradient: 'linear-gradient(135deg, #0b8f9a 0%, #146c8a 100%)',
          shadowColor: 'rgba(46, 210, 214, 0.38)'
        },
        terminate: {
          icon: 'ios-square',
          type: 'error',
          text: this.langMap.stop[this.lang],
          confirmContent: this.langMap.confirmStopTask[this.lang], 
          successMsg: this.langMap.stopSuccess[this.lang],
          endpoint: 'stop',
          gradient: 'linear-gradient(135deg, rgb(223 19 38) 0%, rgb(201 50 0) 100%)',
          shadowColor: 'rgba(252, 182, 159, 0.3)'
        },
        playback: {
          icon: 'ios-videocam',
          type: 'info',
          text: this.langMap.playback[this.lang],
          gradient: 'linear-gradient(135deg, #5b4e3c 0%, rgb(127 68 110) 100%)',
          shadowColor: 'rgba(161, 140, 209, 0.3)',
          isRoute: true
        },
        detail: {
          icon: 'ios-information-circle',
          type: 'primary',
          text: this.langMap.cycleDetails[this.lang],
          gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          shadowColor: 'rgba(102, 126, 234, 0.3)',
          isModal: true
        }
      };
    },

    // 创建通用按钮
    createActionButton(h, config, params) {
      const locked = this.actionLocked;
      const baseStyle = {
        marginRight: config.isLast ? '0' : '4px',
        borderRadius: '4px',
        padding: '4px 8px', 
        fontSize: '12px',
        fontWeight: '500',
        background: config.gradient,
        border: 'none',
        color: '#fff',
        boxShadow: `0 2px 4px ${config.shadowColor}`,
        transition: 'all 0.3s ease',
        opacity: locked ? '0.5' : '1',
        cursor: locked ? 'not-allowed' : 'pointer'
      };

      const buttonEvents = {
        mouseenter: (e) => {
          if (locked) return;
          e.target.style.transform = 'translateY(-1px)';
          e.target.style.boxShadow = `0 4px 8px ${config.shadowColor.replace('0.3', '0.4')}`;
        },
        mouseleave: (e) => {
          if (locked) return;
          e.target.style.transform = 'translateY(0)';
          e.target.style.boxShadow = `0 2px 4px ${config.shadowColor}`;
        },
        click: () => this.handleButtonClick(config, params)
      };

      return h('Button', {
        props: {
          type: config.type,
          size: 'small',
          icon: config.icon,
          disabled: locked
        },
        style: baseStyle,
        on: buttonEvents
      }, config.text);
    },

    // 锁定操作按钮3秒（二次确认通过后调用）
    lockActionButtons() {
      this.actionLocked = true;
      if (this.actionLockTimer) {
        clearTimeout(this.actionLockTimer);
      }
      this.actionLockTimer = setTimeout(() => {
        this.actionLocked = false;
        this.actionLockTimer = null;
      }, 3000);
    },

    // 处理按钮点击事件
    handleButtonClick(config, params) {
      // 锁定期间禁止再次触发操作
      if (this.actionLocked) return;

      if (config.isRoute) {
        this.switchPlayback(params.row);
        return;
      }
      
      if (config.isModal) {
        this.showDetail(params.row);
        return;
      }

      // API调用按钮
      this.$Modal.confirm({
        title: this.langMap.systemTip[this.lang],
        content: config.confirmContent,
        onOk: () => this.executeAction(config, params.row.id)
      });
    },

    // 执行API调用
    executeAction(config, taskId) {
      this.$Spin.show();
      api.getData(`task-server/task/execute/${config.endpoint}/${taskId}`, this)
        .then(res => {
          if (res.state == 0) {
            this.$Notice.error({
              title: this.langMap.tip[this.lang],
              desc: res.msg
            });
          } else {
            this.$Notice.success({
              title: this.langMap.tip[this.lang],
              desc: res.msg || config.successMsg
            });
            // 接口成功后锁定所有操作按钮3秒
            this.lockActionButtons();
            this.getList();
          }
          this.$Spin.hide();
        });
    },
    //获取列表
    getList() {
      this.tableLoading = true;
      this.searchForm.robotId = this.searchForm.robotId
        ? this.searchForm.robotId
        : "";
      this.searchForm.taskId = this.searchForm.taskId
        ? this.searchForm.taskId
        : "";
      this.searchForm.status = this.searchForm.status
        ? this.searchForm.status
        : "";
      api
        .getData(
          "task-server/task/execute/list?index=" +
            this.index +
            "&robotId=" +
            this.searchForm.robotId +
            "&taskId=" +
            this.searchForm.taskId +
            "&status=" +
            this.searchForm.status,
          this
        )
        .then(res => {
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.tip[this.lang],
              desc: res.msg
            });
          } else {
            this.taskExecuteList = res.data.rows;
            this.total = res.data.total;
          }
          this.tableLoading = false;
        });
    },
    //搜索数据
    searchData() {
      this.index = 1;
      this.getList();
    },
    //分页数据
    goPageData(index) {
      this.index = index;
      this.getList();
    },

    getDic() {
      api.getData("task-server/path/get/dic", this).then(res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg
          });
        } else {
          this.taskExecuteStatusList = res.data.taskExecuteStatus;
          this.taskExecuteTaskTypeList = res.data.taskExecuteTaskTypes;
        }
      });
    },
    getRobot() {
      api.getData("robot-server/robot/list/all", this).then(res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: "提示",
            desc: res.msg
          });
        } else {
          this.robotList = res.data;
        }
      });
    },
    getTask() {
      api.getData("task-server/task/listAll?status=2", this).then(res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg
          });
        } else {
          this.taskList = res.data;
        }
      });
    },

    // 跳转
    switchPlayback(row) {
      this.$router.push({
        name: "trackHistory",
        path: "/trackHistory",
        query: {
          id: row.id,
          robotId: row.robotId,
          name: row.robotName
        }
      });
    },

    // 获取详情数据
    getDetailList() {
      this.detailLoading = true;
      api.getData(
        `task-server/task/execute/detail/${this.currentDetailId}?index=${this.detailIndex}`,
        this
      ).then(res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg
          });
        } else {
          this.detailList = res.data.rows;
          this.detailTotal = res.data.total;
        }
        this.detailLoading = false;
      });
    },

    // 详情分页切换
    handleDetailPageChange(index) {
      this.detailIndex = index;
      this.getDetailList();
    },

    // 打开详情弹窗
    showDetail(row) {
      this.currentDetailId = row.id;
      this.detailIndex = 1;
      this.detailModal = true;
      this.getDetailList();
    }
  },
  created() {
    this.getDic();
    this.getList();
    this.getRobot();
    this.getTask();
  },
  beforeDestroy() {
    if (this.actionLockTimer) {
      clearTimeout(this.actionLockTimer);
      this.actionLockTimer = null;
    }
  }
};
</script>

<style>
</style>
